$(window).ready(function () {

    $('.picture-teaser__play-button')
        .on('click', function (event) {

            $(this).removeClass('picture-teaser__play-button');

            var shortVideo = $(this).find('.short-video');
            var fullVideo = $(this).find('.full-video');

            shortVideo.css("display", "none");
            fullVideo.css("display", "block");

            var video = $(fullVideo).find('video').get(0);
            video.play();

            if (navigator.userAgent.match(/iPhone/i)
            ) {
                video.webkitEnterFullscreen();
            }

            video.requestFullscreen();

        });
});
